module.exports = __webpack_public_path__ + "img/down.28719904.svg";